export const BASE_URL = process.env.REACT_APP_API_BASE_URL!;

export const API_ENDPOINTS = {
  LOGIN: "/auth/login",
  CUSTOMERS: "/customers",
  CATEGORIES: "/categories",
  STORES: "/stores",
  PRODUCTS: "/products",
  DELIVERY_PRICE: "/delivery_price",
  ORDERS: "/orders",
  DOWNLOAD_RECEIPT: "/download_receipt",
  DOWNLOAD_MULTIPLE_RECEIPTS: "/download_multiple_receipts",
  TRANSACTIONS: "/transactions",
  REPORTS: "/reports",
  PER_PRODUCT: "/per_product",
  PER_STORE: "/per_store",
  SEARCH: "/search",
  UPLOAD_FILE: "/upload_file",
  LIST: "/list",
};
